import Bellefont121 from './Bellefont 12.webp'
import Bellefont122 from './Bellefont 12 (2).webp'


const Bellefont12images =[
Bellefont121,Bellefont122
]

export default Bellefont12images;